
export { default as ArrowsCirclepathIcon } from "./ArrowsCirclepath.js"
export { default as TrashIcon } from "./Trash.js"